
// ================================
// 🌐 Fonction utilitaire : Récupération des éditos via API
// ================================
const fetchEditorials = async (category) => {
  const basePath = "barletsoeurs/editorials.json";
  const categoryPath =
    category && category !== "tout"
      ? `/${encodeURIComponent(category)}`
      : "/tout";
  const url = new URL(`${basePath}${categoryPath}`, window.location.origin);

  try {
    const res = await fetch(url.toString());
    const json = await res.json();
    return json.editorials || [];
  } catch (e) {
    console.error("Erreur lors du chargement des éditos :", e);
    return [];
  }
};

// ================================
// 📦 Fonction principale : Chargement des produits
// ================================
export function loadProducts(gsap) {
  let allEditorials = window.initialEditorials || [];

  const initialCount = document.querySelectorAll(
    ".products-grid .product"
  ).length;
  let productCounterGlobal = 0;

  const productsPerPage = 12;
  let totalProductCount = document.querySelectorAll(
    ".products-grid .product"
  ).length;
  let page = Math.floor(totalProductCount / productsPerPage) + 1;
  let pcount = totalProductCount;

  let editorialIndex = document.querySelectorAll(
    ".products-grid .edito-content"
  ).length;
  let loading = false;
  let currentCategory = "tout";

  const match = window.location.pathname.match(/category[;:]([^/]+)/);
  if (match) {
    currentCategory = decodeURIComponent(match[1]);
  }
  if (currentCategory && currentCategory !== "tout") {
    window.dispatchEvent(
      new CustomEvent("categoryChanged", {
        detail: { category: currentCategory },
      })
    );
  }

  const grid = document.querySelector(".products-grid");

  const trigger = document.querySelector("#product-loader-trigger");
  let observer = null;

  const getApiUrl = (page, category = currentCategory) => {
    const apiBase = grid.dataset.api;
    const url = new URL(apiBase, window.location.origin);

    url.searchParams.set("page", page);
    if (category && category !== "tout") {
      url.searchParams.set("category", category);
    }

    return url.toString();
  };

  const createProductGroup = () => {
    const group = document.createElement("div");
    group.className = "product-group";
    return group;
  };



// ================================
// 🧱 Fonction utilitaire : Génère le HTML pour un bloc éditorial
// ================================
const createEditorialHTML = (editorial) => {
    const wrapper = document.createElement("div");
    wrapper.className = "edito-content big";

    let content = `<picture>`;
    if (editorial.imageWebp) {
      content += `<source srcset="${editorial.imageWebp}" type="image/webp">`;
    }
    content += `<img src="${editorial.image}" alt="" loading="lazy"></picture>`;

    if (editorial.text) {
      content += `<div class="edito-text">${editorial.text}</div>`;
    }

    if (editorial.link) {
      wrapper.innerHTML = `<a href="${editorial.link}">${content}</a>`;
    } else {
      wrapper.innerHTML = content;
    }

    if (editorialIndex % 2 === 0) {
      wrapper.classList.add("odd");
    } else {
      wrapper.classList.add("even");
    }

    return wrapper;
  };

  const updateUrl = (category) => {
    const basePath = window.location.pathname.replace(
      /\/category[:;][^/]+/g,
      ""
    );
    const newUrl =
      category && category !== "tout"
        ? `${basePath}/category;${encodeURIComponent(category)}`
        : basePath;

    window.history.replaceState({}, "", newUrl);
  };

// ================================
// 🧱 Fonction utilitaire : Génère le HTML pour un produit
// ================================
const createProductHTML = (product, index) => {
    const div = document.createElement("div");
    const classes = [" product product-item"];

    div.className = classes.join(" ");
    div.id = `product-${(page - 1) * 12 + index + 1}`;

    const sizes = "(min-width: 1200px) 33vw, (min-width: 600px) 50vw, 100vw";

    let innerContent = "";

    if (product.cover && product.coverHover) {
      innerContent += `
      <a href="${product.url}" class="product-link">
            <div class="product-cover-wrapper">
          
                <div class="product-images">
                    <picture class="product-cover">
                        ${
                          product.coverWebp
                            ? `<source srcset="${product.coverWebp}" sizes="${sizes}" type="image/webp">`
                            : ""
                        }
                        <img alt="${product.title}" src="${
        product.cover
      }" width="${product.coverWidth || ""}" height="${
        product.coverHeight || ""
      }">
                    </picture>
                    <picture class="product-cover-hover">
                        ${
                          product.coverHoverWebp
                            ? `<source srcset="${product.coverHoverWebp}" sizes="${sizes}" type="image/webp">`
                            : ""
                        }
                        <img alt="${product.title} - hover" src="${
        product.coverHover
      }"
                             width="${product.coverHoverWidth || ""}" height="${
        product.coverHoverHeight || ""
      }">
                    </picture>
                </div>`;
    } else if (product.cover) {
      innerContent += `<a href="${product.url}" class="product-link">
            <div class="product-cover-wrapper">
                <picture class="product-cover">
                    ${
                      product.coverWebp
                        ? `<source srcset="${product.coverWebp}" sizes="${sizes}" type="image/webp">`
                        : ""
                    }
                    <img alt="${product.title}" src="${product.cover}"
                         width="${product.coverWidth || ""}" height="${
        product.coverHeight || ""
      }">
                </picture>`;
    }

    if (product.badges && product.badges.length > 0) {
      innerContent += `
                <div class="info">
                    <div class="badges">
                        ${product.badges
                          .map(
                            (b) =>
                              `<span class="badge badge-${b.key}">${b.label}</span>`
                          )
                          .join("")}
                    </div>
                </div>`;
    }

    if (product.cover) {
      innerContent += `
            </div>`;
    }

    innerContent += `<h2 class="product-title">${product.title}</h2></a>`;

    div.innerHTML = innerContent;

    return div;
  };
  // 🏗️ Création du groupe de produits

  const editorialSpacingTout = [12, 8, 16, 8, 16, 8, 16, 8, 16, 8, 16, 8, 16, 8, 16, 8, 16];
  const editorialSpacingCategory = [4, 8, 16, 8, 16];

  let editorialSpacing = editorialSpacingTout;
  let currentSpacingIndex = 0;
  let nextEditorialAt = editorialSpacing[0];


  const loadProducts = async (customCategory = null) => {
      const categoryToUse = customCategory || currentCategory;
      if (loading) return;
      loading = true;

  

      editorialSpacing = (customCategory || categoryToUse) === "tout"
        ? editorialSpacingTout
        : editorialSpacingCategory;

      if (customCategory && customCategory !== currentCategory) {
        currentCategory = customCategory;
        editorialIndex = 0;
        productCounterGlobal = 0;
        currentSpacingIndex = 0;
        nextEditorialAt = editorialSpacing[0];
        allEditorials = await fetchEditorials(customCategory);
      }

      if (allEditorials.length === 0) {
        allEditorials = await fetchEditorials(categoryToUse);
        editorialIndex = 0;
        productCounterGlobal = 0;
        currentSpacingIndex = 0;
        nextEditorialAt = editorialSpacing[0];
      }

      

    fetch(getApiUrl(page, categoryToUse))
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((res) => {
        if (!res || !Array.isArray(res.items)) {
          console.error("Réponse invalide :", res);
          return;
        }

        let group = createProductGroup();
        let groupItemCount = 0;

        res.items.forEach((p, index) => {
          const el = createProductHTML(p, index);
          group.appendChild(el);
          pcount++;
          productCounterGlobal++;

          if (el) {
            gsap.fromTo(
              el,
              { opacity: 0 },
              { opacity: 1, duration: 0.5, delay: index * 0.03 }
            );
          }

          totalProductCount++;
          groupItemCount++;

          if ( productCounterGlobal >= nextEditorialAt && allEditorials && editorialIndex < allEditorials.length  ) {
            if (groupItemCount > 0) {
              grid.appendChild(group);
              group = createProductGroup();
              groupItemCount = 0;
            }
          

            const editorial = createEditorialHTML(
              allEditorials[editorialIndex]
            );
            grid.appendChild(editorial);
            gsap.fromTo(
              editorial,
              { opacity: 0 },
              { opacity: 1, duration: 0.6 }
            );

            editorialIndex++;

            currentSpacingIndex = (currentSpacingIndex + 1) % editorialSpacing.length;
            nextEditorialAt += editorialSpacing[currentSpacingIndex];
          }

          if (groupItemCount === 4) {
            grid.appendChild(group);
            group = createProductGroup();
            groupItemCount = 0;
          }
        });

        if (groupItemCount > 0) {
          grid.appendChild(group);
        }

        if (res.done || res.items.length === 0) {
          if (observer) observer.unobserve(trigger);
          loading = false;
          return;
        }

        page++;
        loading = false;
      })
      .catch((err) => {
        console.error("Erreur lors du chargement :", err);
        loading = false;
      });
  };
  // 👁️ Initialisation de l’observer (intersection) pour charger plus


// ================================
// 👁️ Fonction utilitaire : Initialise l'observer pour le scroll infini
// ================================
const initObserver = () => {
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadProducts();
        }
      },
      { rootMargin: "300px" }
    );

    if (trigger) observer.observe(trigger);
  };

  initObserver();

  // 🧭 Gestion des clics sur les filtres de catégories


// ================================
// 🧭 Événement : Gestion des clics sur les catégories
// ================================
document.querySelectorAll(".category-item").forEach((link) => {
    if (document.querySelector(".shop-template")) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const category = link.dataset.category || "tout";
        if (category !== currentCategory) {
          page = 1;
          loading = false;
          currentCategory = category;
          editorialSpacing =
            category === "tout"
              ? editorialSpacingTout
              : editorialSpacingCategory;
          currentSpacingIndex = 0;
          nextEditorialAt = editorialSpacing[0];
          allEditorials = []; // important : force le rechargement

          grid.innerHTML = "";

          window.dispatchEvent(
            new CustomEvent("categoryChanged", {
              detail: { category },
            })
          );
          pcount = 0;
          productCounterGlobal = 0; // Reset global counter
          updateUrl(category);
          loadProducts(category);
          initObserver(); // tu peux déplacer ça après le load si besoin
        }

        document
          .querySelectorAll(".category-item")
          .forEach((el) => el.classList.remove("active"));
        link.classList.add("active");
      });
    }
  });
}
